<app-modal *ngIf="vo$ | async; let vo">
	<div modal-body class="app-formula-action-popup">
		<div class="app-formula-action-popup__element">
			<ng-container *ngIf="!vo.isMultipleElement">
				<span i18n="@@formula.action.popup.concernedElement">
					concerned Element
				</span>
				<span class="app-formula-action-popup__element-label">
					{{ vo.element }}
				</span>
			</ng-container>
			<ng-container *ngIf="vo.isMultipleElement">
				<span i18n="@@formula.action.popup.concernedElements">
					concerned Elements
				</span>
				<div class="app-formula-action-popup__element-label">
					{{ vo.formulaId.length }}
					<span i18n="@@formula.action.popup.formulas">formulas</span>
				</div>
			</ng-container>
		</div>
		<ng-container [ngSwitch]="vo.action">
			<div
				*ngSwitchCase="FormulaAction.Delete"
				class="app-formula-action-popup__delete">
				<span
					*ngIf="vo.isMultipleElement"
					class="app-formula-action-popup__description"
					i18n="@@formula.action.popup.delete.multiple.description">
					deletion request
				</span>
				<span
					*ngIf="!vo.isMultipleElement"
					class="app-formula-action-popup__description"
					i18n="@@formula.action.popup.delete.description">
					deletion request
				</span>

				<div class="app-formula-action-popup__delete-info">
					<mat-icon [svgIcon]="DcIcons.Warning"></mat-icon>
					<span
						*ngIf="vo.isMultipleElement"
						class="app-formula-action-popup__message"
						i18n="@@formula.action.popup.delete.multiple.info">
						deletion info
					</span>
					<span
						*ngIf="!vo.isMultipleElement"
						class="app-formula-action-popup__message"
						i18n="@@formula.action.popup.delete.info">
						deletion info
					</span>
				</div>
				<div class="app-formula-action-popup__checkbox">
					<mat-checkbox
						id="{{ cmpId }}-confirm-checkbox"
						color="primary"
						[(ngModel)]="confirmDeletion">
							<span i18n="@@formula.action.popup.delete.confirm">confirm delete</span>
					</mat-checkbox>
				</div>
			</div>
			<div *ngSwitchCase="FormulaAction.Duplicate">
				<span
					class="app-formula-action-popup__description"
					i18n="@@formula.action.popup.duplicate.description">
					duplicate
				</span>
			</div>
		</ng-container>
	</div>

	<div modal-footer class="app-formula-action-popup__footer">
		<ng-container [ngSwitch]="vo.action">
			<button
				*ngSwitchCase="FormulaAction.Delete"
				id="{{ cmpId }}-delete-btn"
				class="app-formula-action-popup__footer__btn"
				[color]="'warn'"
				[disabled]="!confirmDeletion"
				(click)="confirmAction()"
				mat-raised-button>
				<mat-icon [svgIcon]="DcIcons.Delete"></mat-icon>
				<span i18n="@@formula.action.popup.delete.btn">delete</span>
			</button>
			<button
				*ngSwitchCase="FormulaAction.Duplicate"
				id="{{ cmpId }}-duplicate-btn"
				class="app-formula-action-popup__footer__btn"
				(click)="confirmAction()"
				mat-raised-button>
				<span i18n="@@formula.action.popup.duplicate.btn">duplicate</span>
			</button>
		</ng-container>
	</div>
</app-modal>
